import { FC, useContext, useMemo } from "react";
import { InlineFormTabbedPresentation } from "./TabbedPresentation";
import { InlineFormFlatPresentation } from "./FlatPresentation";
import { InlineSingleRowProps, useInlineContext } from "@data-root/react";

export const enum InlineFormPresentation {
  Tabbed = "Tabbed",
  Flat = "Flat",
}

export const Form: FC<InlineSingleRowProps> = (props) => {
  const { options } = useInlineContext();
  const { presentation } = options || {};

  const Presentation = useMemo(() => {
    switch (presentation) {
      case InlineFormPresentation.Flat:
        return <InlineFormFlatPresentation {...props} />;
      case InlineFormPresentation.Tabbed:
      default:
        return <InlineFormTabbedPresentation {...props} />;
    }
  }, [presentation, props]);

  return Presentation;
};
